import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { APP_ICONS, ICON_DEFAULT_SIZE, ICON_DEFAULT_STROKE_WIDTH } from './icons';

@Directive({ selector: '[ssIcon]', standalone: false })
export class IconDirective implements OnChanges {
  @Input() ssIcon = '';
  private svg?: SVGElement;

  constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnChanges() {
    if (this.svg) this.renderer.removeChild(this.element.nativeElement, this.svg);
    this.svg = undefined;
    const key = this.ssIcon.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('');
    const nodes = (APP_ICONS as any)[key] as [string, Record<string, string>][] | undefined;
    if (!nodes) return;
    const svg = this.renderer.createElement('svg', 'svg');
    const attributes = { width: ICON_DEFAULT_SIZE, height: ICON_DEFAULT_SIZE, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': ICON_DEFAULT_STROKE_WIDTH, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' };
    Object.entries(attributes).forEach(([name, value]) => this.renderer.setAttribute(svg, name, String(value)));
    nodes.forEach(([tag, attrs]) => {
      const child = this.renderer.createElement(tag, 'svg');
      Object.entries(attrs).filter(([name]) => name !== 'key').forEach(([name, value]) => this.renderer.setAttribute(child, name, String(value)));
      this.renderer.appendChild(svg, child);
    });
    this.renderer.insertBefore(this.element.nativeElement, svg, this.element.nativeElement.firstChild);
    this.renderer.addClass(this.element.nativeElement, 'ss-inline-icon');
    this.svg = svg;
  }
}
